import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { FooterComponent } from "../shared/footer/footer.component";
import { HeaderComponent } from "../shared/header/header.component";

@Component({
	selector: "app-orgadmin",
	templateUrl: "./orgadmin.component.html",
	styleUrls: ["./orgadmin.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class OrgadminComponent {

}
